import {
  AfterViewInit,
  Component,
  ElementRef, Inject,
  Input,
  OnDestroy, OnInit,
  Renderer2,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import {AccountService} from "@aparraga/ahoracrypto-client-common/src/app/common/account/account.service";
import {User} from "@aparraga/ahoracrypto-client-common/src/app/common/domain/user";
import {Router} from "@angular/router";
import {Subscription} from "rxjs";
import {ScrollService} from "../../scroll/scroll.service";
//import GLightbox from 'glightbox';
import {NavbarService} from "./navbar.service";
import {NavigationService} from "@aparraga/ahoracrypto-client-common/src/app/common/navigation/navigation.service";
import {CacheService} from "@aparraga/ahoracrypto-client-common/src/app/common/cache/cache.service";
import {ContentControllerService} from "@aparraga/ahoracrypto-api-sdk/sdk/api/contentController.service";
import {DropdownOptions} from "flowbite";
import {IS_BROWSER} from "@aparraga/ahoracrypto-client-common/src/app/common/utils/injectiontokens";
import {GlightboxService} from "../../glightbox/glightbox.service";
import { ExchangeService } from '@aparraga/ahoracrypto-client-common/src/app/common/exchange/exchange.service';
import { PurchaseFlowHelperService } from '@aparraga/ahoracrypto-client-common/src/app/common/flowhelpers/purchaseflowhelper.service';
import { I18nServices } from '@aparraga/ahoracrypto-client-common/src/app/common/i18n/i18n.service';
import {ContentService} from "../../content/content.service";

declare var Dropdown: any;
declare var $: any;
declare var GLightbox: any;

@Component({
    selector: 'navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class NavbarComponent implements AfterViewInit, OnDestroy {

  @Input()
  public darkMode: boolean = true;

  @Input()
  public logoDark: boolean = false;

  @Input()
  public showSections = true;

  @Input()
  public showNavbar = true;

  @ViewChild('dropdownMainMenu') public dropdownMainMenuElement: ElementRef;
  @ViewChild('triggerMenuButton') public triggerMenuButtonElement: ElementRef;

  @ViewChild('exploreMenu') public exploreMenuElement: ElementRef;
  @ViewChild('learnMenu') public learnMenuElement: ElementRef;

  protected subscriptions: Subscription[] = new Array<Subscription>();

  @ViewChild('navbar') public navBar: ElementRef;

  protected mainMenu: any;

  protected lightbox: any;

  public userInSession: User = null;

  public learnMenuVisible: boolean = false;
  public exploreMenuVisible: boolean = false;

  public currenciesList = [];
  public highlightArticles: any[] = [];
  public fixedContent: any[] = [];

  public constructor(protected accountService: AccountService,
                     private renderer: Renderer2,
                     protected navbarService: NavbarService,
                     protected cacheService: CacheService,
                     protected gLightboxService: GlightboxService,
                     protected contentControllerService: ContentControllerService,
                     protected navigationServices: NavigationService,
                     @Inject(IS_BROWSER) protected isBrowser: boolean,
                     protected scrollService: ScrollService,
                     public exchangeService: ExchangeService,
                     public purchaseFlowHelperService: PurchaseFlowHelperService,
                     protected i18nServices: I18nServices,
                     protected router: Router,
                     protected contentService: ContentService) {

    this.navbarService.registerTargetComponent(this);

  }

  public ngAfterViewInit() {

    if(this.showNavbar) {

      this.accountService.userSubject$.subscribe(user => {
        this.userInSession = user;
      });

      this.exchangeService.exchangePricesSubject$.subscribe(async exchangeRates => {
        if(exchangeRates != null && Object.keys(exchangeRates).length > 0 && this.currenciesList.length == 0) {
  
          this.currenciesList = this.exchangeService.getExchangePricesOrderByMarketCap(this.purchaseFlowHelperService.selectedCurrency, 9);
        }
      });
  
      this.contentService.loadLatest3Article().then((contents) => {
        this.highlightArticles = contents;
      });
  
      this.contentService.loadFixedContent().then((contents) => {
        this.fixedContent = contents;
      });      

      this.subscriptions.push(this.scrollService.scrollPositionY.subscribe(positionY => {
        if(this.navBar != null) {
          if (positionY >= 15) {
            if (this.darkMode) {
              this.renderer.addClass(this.navBar.nativeElement, 'white-bg-navbar');
              this.renderer.removeClass(this.navBar.nativeElement, 'transparent-bg-navbar');
            } else {
              this.renderer.removeClass(this.navBar.nativeElement, 'white-bg-bottom-separator-navbar');
            }
            this.renderer.addClass(this.navBar.nativeElement, 'white-bg-shadow-navbar');
          } else {
            if (this.darkMode) {
              this.renderer.addClass(this.navBar.nativeElement, 'transparent-bg-navbar');
              this.renderer.removeClass(this.navBar.nativeElement, 'white-bg-navbar');
            } else {
              this.renderer.addClass(this.navBar.nativeElement, 'white-bg-bottom-separator-navbar');
            }
            this.renderer.removeClass(this.navBar.nativeElement, 'white-bg-shadow-navbar');
          }
        }
      }));

      if (this.isBrowser) {
        this.loadMainMenu();
        this.gLightboxService.load().then(result => {
          this.lightbox = GLightbox({
            'href': $localize`https://youtube.com/watch?v=Pb1hV2HtcxE`,
            'type': 'video',
            'source': 'youtube', //vimeo, youtube or local
            'width': 940,
            'height': 528,
            'thumbnailUrl': 'https://i.ytimg.com/vi/eSnGmr19Uo4/hqdefault.jpg',
            'autoplayVideos': true,
          });
        });

      }

    }

  }

  public loadMainMenu() {
    const options: DropdownOptions = {
      onShow: () => {
        this.preloadContent();
      },
    };
    this.mainMenu = new Dropdown(this.dropdownMainMenuElement.nativeElement, this.triggerMenuButtonElement.nativeElement, options);
  }

  public ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  public logout() {
    this.accountService.logout();
    this.router.navigate(['/']);
  }

  public goToLogin() {
    this.router.navigate(['/login/enteremail']);
  }

  public closeMainMenu() {
    this.mainMenu.hide();
  }

  public showMenu() {
    this.mainMenu.show();
  }

  public goToBuyForm() {
    this.closeMainMenu();
    if(this.navigationServices.getCurrentUrl() == '/') {
      $('html,body').animate({
        scrollTop: 0
      }, 'slow');
    }
    else {
      this.router.navigate(['/']);
    }
  }

  public preloadContent() {
      if(!this.cacheService.hasLatest3Articles()) {
        this.contentControllerService.contentControllerFindAll(1, 3).subscribe((contents) => {
          //add all articles to cache
          contents.pop(); //always remove last one!
          this.cacheService.setLatest3Articles(contents);
        });
      }
  }

  public openExploreMenu() {
    if(this.exploreMenuVisible) {
      this.exploreMenuElement.nativeElement.classList.add('dropdown-list-visible');
      this.exploreMenuElement.nativeElement.classList.remove('dropdown-list-hidden');
    }
  }

  public closeExploreMenu(force: boolean = false) {
    setTimeout(() => {
      if (!this.exploreMenuVisible || force) {
        this.exploreMenuElement.nativeElement.classList.add('dropdown-list-hidden');
        this.exploreMenuElement.nativeElement.classList.remove('dropdown-list-visible');
        this.exploreMenuVisible = false;
      }
    }, 200);
  }

  public openLearnMenu() {
    if(this.learnMenuVisible) {
      this.learnMenuElement.nativeElement.classList.add('dropdown-list-visible');
      this.learnMenuElement.nativeElement.classList.remove('dropdown-list-hidden');
      this.preloadContent();
    }
  }

  public closeLearnMenu(force: boolean = false) {
    setTimeout(() => {
      if (!this.learnMenuVisible || force) {
        this.learnMenuElement.nativeElement.classList.add('dropdown-list-hidden');
        this.learnMenuElement.nativeElement.classList.remove('dropdown-list-visible');
        this.learnMenuVisible = false;
      }
    }, 200);
  }

  public getTimeAgo(dateString: string): string {
    const publishedDate = new Date(dateString);
    const currentDate = new Date();
    const diffInMs = currentDate.getTime() - publishedDate.getTime();
    const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60));
    const diffInDays = Math.floor(diffInHours / 24);

    if (diffInDays > 0) {
      return `Hace ${diffInDays} días`;
    } else {
      return `Hace ${diffInHours} horas`;
    }
  }
}
